(function (angular, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.JoinForm
        .factory('FieldOptionsModel', ['$http', '$q', function ($http, $q) {
            var localJSONFiles = false;
            var FieldOptionsModel = function () {

            };

            FieldOptionsModel.prototype = {
                all: function () {
                    var deferred = $q.defer();
                    var callsRemaining = 3;
                    var success = true;
                    var response = {
                        healthFunds: [],
                        titles: [],
                        relationships: {}
                    };

                    function doResponse(data, type) {
                        callsRemaining--;
                        if (success && typeof data.result === 'boolean') {
                            success = data.result;
                        }
                        else {
                            success = false;
                        }
                        response[type] = data.content;

                        if (callsRemaining === 0) {
                            if (success) {
                                deferred.resolve(response);
                            }
                            else {
                                deferred.reject(response);
                            }
                        }
                    }

                    this.byType('healthFunds').then(function (data) {
                        doResponse(data, 'healthFunds');
                    }, function (data) {
                        doResponse(data, 'healthFunds');
                    });
                    this.byType('titles').then(function (data) {
                        doResponse(data, 'titles');
                    }, function (data) {
                        doResponse(data, 'titles');
                    });
                    this.byType('relationships').then(function (data) {
                        doResponse(data, 'relationships');
                    }, function (data) {
                        doResponse(data, 'relationships');
                    });
                    return deferred.promise;
                },

                /**
                 *
                 * @param type
                 * @returns {deferred.promise|{then, always}}
                 */
                byType: function (type) {
                    var deferred = $q.defer();

                    var url = false;
                    var formatData = function (response) {
                        return response;
                    };
                    if (type === 'healthFunds') {
                        if (localJSONFiles) {
                            url = '/static/js/src/Angular/thfJoinForm/json/health-funds.json';
                        }
                        else {
                            url = '/api/v1/data/health-funds';
                        }
                        formatData = this.formatDataHealthFunds;
                    }
                    else if (type === 'titles') {
                        if (localJSONFiles) {
                            url = '/static/js/src/Angular/thfJoinForm/json/titles.json';
                        }
                        else {
                            url = '/api/v1/data/titles';
                        }
                        formatData = this.formatDataTitles;
                    }
                    else if (type === 'relationships') {
                        if (localJSONFiles) {
                            url = '/static/js/src/Angular/thfJoinForm/json/relationships.json';
                        }
                        else {
                            url = '/api/v1/data/relationships';
                        }
                        formatData = this.formatDataRelationships;
                    }

                    $http.get(url, {
                            cache: true
                        })
                        .success(function (data) {
                            deferred.resolve(formatData.call(null, data));
                        })
                        .error(function () {
                            deferred.reject({
                                result: false,
                                message: 'No response from server',
                                content: ''
                            });
                        });
                    return deferred.promise;
                },
                formatDataHealthFunds: function (response) {
                    if (response.result) {
                        if (response.content.length > 0) {
                            var formattedContent = [];
                            for (var i = 0; i < response.content.length; i++) {
                                var item = response.content[i];

                                if (item.HealthFundCode != 599) {
                                    formattedContent.push({
                                        value: item.HealthFundCode,
                                        label: item.Name
                                    });
                                }
                            }
                            response.content = formattedContent;
                        }
                    }

                    return response;
                },
                formatDataTitles: function (response) {
                    if (response.result) {
                        if (response.content.length > 0) {
                            var formattedContent = [];
                            for (var i = 0; i < response.content.length; i++) {
                                var item = response.content[i];
                                var gender = null;
                                if (item.IsMale && item.IsFemale) {
                                    gender = null;
                                }
                                else if (item.IsMale) {
                                    gender = 'M';
                                }
                                else if (item.IsFemale) {
                                    gender = 'F';
                                }

                                formattedContent.push({
                                    value: item.TitleCode,
                                    label: item.Description,
                                    gender: gender
                                });
                            }
                            response.content = formattedContent;
                        }
                    }

                    return response;
                },
                formatDataRelationships: function (response) {
                    if (response.result) {
                        if (response.content.length > 0) {
                            var formattedContent = {
                                'partner': [],
                                'dependants': []
                            };
                            for (var i = 0; i < response.content.length; i++) {
                                var item = response.content[i];

                                var gender = null;
                                if (item.IsMale && item.IsFemale) {
                                    gender = null;
                                }
                                else if (item.IsMale) {
                                    gender = 'M';
                                }
                                else if (item.IsFemale) {
                                    gender = 'F';
                                }

                                if (item.RelationshipType == 'Partner') {
                                    formattedContent.partner.push({
                                        value: item.RelationshipCode,
                                        label: item.Description,
                                        gender: gender
                                    });
                                }
                                else if (item.RelationshipType == 'ChildDependant' || item.RelationshipType == 'AdultDependant') {
                                    formattedContent.dependants.push({
                                        value: item.RelationshipCode,
                                        label: item.Description,
                                        gender: gender
                                    });
                                }
                            }
                            response.content = formattedContent;
                        }
                    }

                    return response;
                }
            };

            return new FieldOptionsModel();
        }]);

})(angular, window);
